export default "__VITE_PUBLIC_ASSET__8e14d303__"